import { Phone, ScanLine } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, SCAN_URL } from "../lib/site";

export const StickyCTA = () => (
  <div className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 gap-2 border-t border-white/10 bg-ink/90 p-3 backdrop-blur-xl md:hidden" style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}>
    <a
      data-testid="sticky-call-button"
      href={PHONE_TEL}
      className="inline-flex items-center justify-center gap-2 rounded-full border border-cy/50 py-3.5 font-semibold text-sm text-cy"
    >
      <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
    </a>
    <a
      data-testid="sticky-scan-button"
      href={SCAN_URL}
      target="_blank"
      rel="noopener noreferrer sponsored"
      className="inline-flex items-center justify-center gap-2 rounded-full bg-brandamber py-3.5 font-bold text-sm text-ink active:scale-95"
    >
      <ScanLine className="h-4 w-4" /> FREE Scan
    </a>
  </div>
);
